define('fileExtensionData',[
  'module'
], function(module) {
  'use strict';

  module.exports = {
    extensions: [{
      extension: '.ai (Adobe Illustrator CS2)',
      isVectorFormat: true,
      format3d: false
    },{
      extension: '.ai (Adobe Illustrator CS4)',
      isVectorFormat: true,
      format3d: false
    },{
      extension: '.ai (Adobe Illustrator CS5)',
      isVectorFormat: true,
      format3d: false
    },{
      extension: '.ai (Adobe Illustrator CS6)',
      isVectorFormat: true,
      format3d: false
    },{
      extension: '.ai (Adobe Illustrator CC)',
      isVectorFormat: true,
      format3d: false
    },{
      extension: '.pdf (PDF 1.4)',
      isVectorFormat: true,
      format3d: false
    },{
      extension: '.pdf (PDF 1.5)',
      isVectorFormat: true,
      format3d: false
    },{
      extension: '.pdf (PDF 1.6)',
      isVectorFormat: true,
      format3d: false
    },{
      extension: '.pdf (PDF 1.7)',
      isVectorFormat: true,
      format3d: false
    },{
      extension: '.psd (Photoshop Document)',
      isVectorFormat: false,
      format3d: false
    },{
      extension: '.cdr (Corel Draw X3)',
      isVectorFormat: true,
      format3d: false
    },{
      extension: '.cdr (Corel Draw X4)',
      isVectorFormat: true,
      format3d: false
    },{
      extension: '.cdr (Corel Draw X5)',
      isVectorFormat: true,
      format3d: false
    },{
      extension: '.cdr (Corel Draw X6)',
      isVectorFormat: true,
      format3d: false
    },{
      extension: '.cdr (Corel Draw X7)',
      isVectorFormat: true,
      format3d: false
    },{
      extension: '.indd (Adobe Indesign CS5)',
      isVectorFormat: true,
      format3d: false
    },{
      extension: '.indd (Adobe Indesign CS6)',
      isVectorFormat: true,
      format3d: false
    },{
      extension: '.indd (Adobe Indesign CC)',
      isVectorFormat: true,
      format3d: false
    },{
      extension: '.eps (Encapsulated Post Script Illustrator CS4)',
      isVectorFormat: true,
      format3d: false
    },{
      extension: '.eps (Encapsulated Post Script Illustrator CS5)',
      isVectorFormat: true,
      format3d: false
    },{
      extension: '.eps (Encapsulated Post Script Illustrator CS6)',
      isVectorFormat: true,
      format3d: false
    },{
      extension: '.eps (Encapsulated Post Script Illustrator CC)',
      isVectorFormat: true,
      format3d: false
    },{
      extension: '.svg (Scalable Vector Graphics 1.1)',
      isVectorFormat: true,
      format3d: false
    },{
      extension: '.svg (Scalable Vector Graphics 1.2)',
      isVectorFormat: true,
      format3d: false
    },{
      extension: '.bmp',
      isVectorFormat: false,
      format3d: false
    },{
      extension: '.gif',
      isVectorFormat: false,
      format3d: false
    },{
      extension: '.jpg',
      isVectorFormat: false,
      format3d: false
    },{
      extension: '.png',
      isVectorFormat: false,
      format3d: false
    },{
      extension: '.tiff',
      isVectorFormat: false,
      format3d: false
    },{
      extension: '.glb (Binary GLTF)',
      isVectorFormat: false,
      format3d: true
    },{
      extension: '.gltf (GL Transmission Format)',
      isVectorFormat: false,
      format3d: true
    }]
  };
});
